import { MaterialTree } from '../models/material-tree';
import { MatTreeFlattener, MatTreeFlatDataSource } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { ItemFlatNode, ItemNode } from '../models/item';
import { SelectionModel } from '@angular/cdk/collections';

export class TreeBuilder {

    public getLevel = (node: ItemFlatNode) => node.level;
    private isExpandable = (node: ItemFlatNode) => node.expandable;
    private getChildren = (node: ItemNode): ItemNode[] => node.children;

    private transformer = (node: ItemNode, level: number) => {
        const nestedNodeMap = new Map<ItemNode, ItemFlatNode>();
        const existingNode = nestedNodeMap.get(node);
        const flatNode = existingNode && existingNode.Id === node.Id ? existingNode : new ItemFlatNode(null);
        flatNode.Id = node.Id;
        flatNode.Description = node.Description;
        flatNode.Order = node.Order;
        flatNode.selectable = true;
        flatNode.maxSelectableChildren = node.maxSelectableChildren;
        flatNode.level = level;
        flatNode.expandable = node.children && node.children.length > 0;
        flatNode.checkable = node.checkable;
        nestedNodeMap.set(node, flatNode);
        return flatNode;
    }

    buildTree(_itemList: ItemNode[]): MaterialTree {
        const treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
        const treeControl = new FlatTreeControl<ItemFlatNode>(this.getLevel, this.isExpandable);
        const dataSource = new MatTreeFlatDataSource(treeControl, treeFlattener);
        dataSource.data = _itemList;
        const checklistSelection = new SelectionModel<ItemFlatNode>(true);
        return {
            treeFlattener,
            treeControl,
            dataSource,
            checklistSelection,
            getLevel: this.getLevel,
            nodesSelectedCounts: {}
        };
    }

}
